import React, { FC, useState, useRef, useEffect } from 'react'
import Modal from 'react-modal'
import { usePromiseTracker } from 'react-promise-tracker'
import { trackPromise } from 'react-promise-tracker'
import moment from 'moment'
import { isMobile } from 'react-device-detect'

import { getUserWeeklyActivity } from '../../../Api/backendApi'

import {
  modalStyles,
  PopupContainer,
  Row,
  Column,
  Image,
  Text,
  CalendarTile,
  ActiveDayCompletedIcon,
  Button,
} from '../../VideoScreen/styles/VideoScreenStyles'

import Loader from '../../Loader/Loader'

import trophyIcon from '../../../assets/player/trophyIcon.webp'

interface AfterCompleteMiazgaPopupProps {
  isAfterCompleteMiazgaPopupOpen: boolean
  toggleAfterCompleteMiazgaPopupOpen: Function
  userCurrentStage: any
}

const AfterCompleteMiazgaPopup: FC<AfterCompleteMiazgaPopupProps> = ({
  isAfterCompleteMiazgaPopupOpen,
  toggleAfterCompleteMiazgaPopupOpen,
  userCurrentStage,
}) => {
  const AfterCompleteMiazgaPopup = useRef(null)
  Modal.setAppElement('#root')

  return (
    <Modal
      ref={AfterCompleteMiazgaPopup}
      isOpen={isAfterCompleteMiazgaPopupOpen}
      onRequestClose={() => toggleAfterCompleteMiazgaPopupOpen(false)}
      style={modalStyles}
    >
      <PopupContainer>
        <Row margin={`5px 0`}>
          <Text
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={isMobile ? 50 : 40}
            display={'inline-block'}
          >
            {userCurrentStage && userCurrentStage.current_stage} ukończona!
          </Text>
        </Row>

        <Row margin={`${isMobile ? '10vh' : '10vh'} 0 0 0 `}>
          <Image
            src={trophyIcon}
            height={
              isMobile
                ? '170px'
                : isMobile && window.innerWidth < 360
                ? '130px'
                : '10vw'
            }
          />
        </Row>

        <Row margin={`${isMobile ? '10vh' : '10vh'} 0 0 0 `}>
          <Text
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={isMobile ? 28 : 28}
            display={'inline-block'}
          >
            Przed Tobą {userCurrentStage && userCurrentStage.next_stage}.
          </Text>
        </Row>
        <Row margin={`5px 0`}>
          <Text
            width={'100%'}
            textAlign={'center'}
            fontWeight={'bold'}
            fontSize={isMobile ? 28 : 28}
            display={'inline-block'}
          >
            Trzymaj się, będzie mocno
          </Text>
        </Row>

        <Row
          margin={`${isMobile ? '10vh' : '10vh'} 0  ${
            isMobile ? '4vh' : '30px'
          } 0`}
        >
          <Button width={'60%'} onClick={toggleAfterCompleteMiazgaPopupOpen}>
            Zamknij
          </Button>
        </Row>
      </PopupContainer>
    </Modal>
  )
}

export default AfterCompleteMiazgaPopup
